import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { SubformBaseComponent } from '@shared/components/subform-base/subform-base.component';

import { SpecialPropertiesSubformComponent } from '../special-properties-subform/special-properties-subform.component';

@Component({
  selector: 'app-optional-product-properties-subform',
  templateUrl: './optional-product-properties-subform.component.html',
  styleUrls: ['./optional-product-properties-subform.component.scss'],
})
export class OptionalProductPropertiesSubformComponent
  extends SubformBaseComponent
  implements OnInit
{
  @Input() readOnly = false;
  DICT_PATH = 'PRODUCTS';

  static buildForm(fb: FormBuilder) {
    return fb.group({
      descriptionOfUsage: [''],
      descriptionOfStorage: [''],
      specialProperties: SpecialPropertiesSubformComponent.buildForm(fb),
    });
  }
}
